import MainAuditsLogs from "../components/audits-log/main-audit";

function AuditsLogs() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainAuditsLogs />
    </div>
  );
}

export default AuditsLogs;